module.exports = require("././angular-route.js");


//////////////////
// WEBPACK FOOTER
// angular-route (bower component)
// module id = 31
// module chunks = 0 1